import { render } from "./arrow-top-right-icon.vue.js?vue&type=template&id=31cb988c!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./arrow-top-right-icon.vue?vue&type=template&id=31cb988c"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__